import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { PrimaryButton } from '@/components/common/Buttons';
import { Image } from '@/components/common/image';
import { PortableText } from '@/components/common/utils';
import { bodySmall, captionSmall } from '@/styles/typography';

import type { SanityExplainerCardType } from '@/types/sanity';

interface ExplainerCardProps extends SanityExplainerCardType {}

const ExplainerCard = ({ title, body, image, CTA }: ExplainerCardProps) => {
  return (
    <Container>
      <ImageContainer>
        <Image {...image} objectFit="contain" height={72} width={100} />
      </ImageContainer>
      {title && <Title>{title} </Title>}
      <PortableText value={body} />
      {!!CTA.text && (
        <ButtonContainer>
          <PrimaryButton componentTheme="light" href={CTA.url}>
            {CTA.text}
          </PrimaryButton>
        </ButtonContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  ${bodySmall}
  display: flex;
  flex-direction: column;
  padding: var(--spacing-small);

  ${screen.sm} {
    padding: var(--spacing-250);
  }
`;

const Title = styled.div`
  ${captionSmall}
  font-weight: var(--font-weight-bold);
  padding-top: var(--spacing-x-small);
  padding-bottom: var(--spacing-xxx-small);
  ${screen.sm} {
    paddin-top: var(--spacing-small);
  }
`;
const ImageContainer = styled.div`
  height: 72px;
  width: 100px;
  img {
    max-height: 72px;
  }
`;

const ButtonContainer = styled.div`
  padding-top: var(--spacing-x-small);
  display: flex;
  height: 100%;
  align-items: flex-end;
  ${screen.sm} {
    padding-top: var(--spacing-small);
  }
`;

export { ExplainerCard };
